import { Link, useParams } from "react-router-dom";
import { PROJECTS, getProject } from "@/data/projects";
import { ProjectHero } from "@/components/project/ProjectHero";
import { CaseSection } from "@/components/project/CaseSection";
import { NextProject } from "@/components/project/NextProject";
import { useMeta } from "@/lib/motion";

const NotFound = () => (
  <section className="px-6 py-40 lg:px-12" data-testid="project-not-found">
    <h1 className="font-display text-5xl font-medium tracking-[-0.04em]">Project not found.</h1>
    <Link to="/#work" className="u-link mt-8 inline-block">Back to selected work</Link>
  </section>
);

export default function ProjectPage() {
  const { slug } = useParams();
  const project = getProject(slug);
  useMeta(
    project ? `${project.title} — Eldiiar Dzhumagaziev` : "Project not found — Eldiiar Dzhumagaziev",
    project ? `${project.summary} ${project.note}` : undefined,
  );
  if (!project) return <NotFound />;
  const next = PROJECTS[(PROJECTS.indexOf(project) + 1) % PROJECTS.length];
  return (
    <article data-testid={`project-page-${project.slug}`}>
      <ProjectHero project={project} />
      {project.sections.map((s, i) => <CaseSection key={s.id} section={s} index={i} />)}
      <NextProject project={next} />
    </article>
  );
}
